import { actionAuditTrail, rolePortalMerchant, statusAuditTrail } from '@/store/params';
import { date } from '../../../../lib/helpers';
import { headers, search } from './attributes';

export default {
  data: () => ({
    options: {},
    headers,
    search,
    filterValue: {
      action_date: [],
      username: '',
      role: '',
      origin_path: '',
      ip_address: '',
      status: '',
      action: ''
    },
    filterType: [
      { key: 'username', type: 'textfield', props: { label: 'Username' } },
      { key: 'role', type: 'select', props: { label: 'Role', items: rolePortalMerchant } },
      { key: 'origin_path', type: 'textfield', props: { label: 'Location Menu' } },
      { key: 'ip_address', type: 'textfield', props: { label: 'IP Address' } },
      { key: 'action', type: 'select', props: { label: 'Action', items: actionAuditTrail } },
      { key: 'status', type: 'select', props: { label: 'Status', items: statusAuditTrail } },
      { key: 'action_date', type: 'daterange', props: { label: 'Action Date & Time', includeToday: true, limitRangeTo30Days: true, defaultToday: true, withTime: true } },
    ],
  }),
  computed: {
    allData() {
      return this.$store.state.auditTrailMerchant.allData;
    },
    totalData() {
      return this.$store.state.auditTrailMerchant.totalData;
    },
    totalPage() {
      return this.$store.state.auditTrailMerchant.totalPage;
    },
    loading() {
      return this.$store.state.auditTrailMerchant.loading;
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
    },
  },
  methods: {
    baseFilterData(newSearch) {
      this.search.action_date = newSearch.action_date || [];
      this.search.username = newSearch.username || '';
      this.search.role = newSearch.role || '';
      this.search.origin_path = newSearch.origin_path || '';
      this.search.ip_address = newSearch.ip_address || '';
      this.search.action = newSearch.action || '';
      this.search.status = newSearch.status || '';
      this.options.page = 1;
      this.getData(); 
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    getData() {
      const { page, itemsPerPage } = this.options;

      this.$store
        .dispatch('auditTrailMerchant/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    copyToClipboard(content) {
      const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : content;
      navigator.clipboard.writeText(text);
    },
    clearSearch() {
      this.search.action_date = [];
      this.search.username = '';
      this.search.role = '';
      this.search.origin_path = '';
      this.search.ip_address = '';
      this.search.status = '';
      this.search.action = '';
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};